/* eslint-disable */

export interface ReviewLoginResult {
  status?: ReviewLoginResultStatus;
  parameters?: Uint8Array;
}

export enum ReviewLoginResultStatus {
  VERIFIED = "VERIFIED",
  REVOKED = "REVOKED",
  PENDING = "PENDING",
}

export interface ReviewNewDeviceLoginParameters {
  flow_token?: string;
  initiate_action_channel?: ActionInitiateActionChannel;
}

export interface AcknowledgeDeviceReviewedParameters {
  deviceDescription?: string;
}

export interface Action {
  initiate_action_channel?: ActionInitiateActionChannel;
  action_timestamp?: number;
  review_login_status?: ReviewLoginResultStatus;
  action_type?: ActionActionType;
}

export enum ActionInitiateActionChannel {
  EMAIL_NOTIFICATION = "EMAIL_NOTIFICATION",
  PUSH_NOTIFICATION = "PUSH_NOTIFICATION",
  ACTIVITY_FEED = "ACTIVITY_FEED",
  DEVICE_MANAGER = "DEVICE_MANAGER",
}

export enum ActionActionType {
  LOGIN_REVIEW = "LOGIN_REVIEW",
  DEVICE_REVIEW = "DEVICE_REVIEW",
}

/** This is intended to be a replacement for other login protos and models. */
export interface JanusLoginAttempt {
  customer_token?: string;
  id?: string;
  created_at?: Date;
  updated_at?: Date;
  last_state_transition_at?: Date;
  state?: JanusLoginAttemptState;
  new_device?: boolean;
  ip_address?: string;
  app_token?: string;
  device_description?: string;
  customer_actions?: Action[];
  geographic_location?: string;
  alias_hash?: string;
}

export enum JanusLoginAttemptState {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
}
